import { render, staticRenderFns } from "./AwardWriteLink.vue?vue&type=template&id=47417b16&scoped=true&"
import script from "./AwardWriteLink.vue?vue&type=script&lang=js&"
export * from "./AwardWriteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47417b16",
  null
  
)

export default component.exports